import AlertTriangle from "./icons/AlertTriangle";
import PrimaryButton from "./PrimaryButton";

// Mock `.dirtybar`: a surface bar with the warn border at the bottom centre while the totals are stale.
function DirtyBar({ message, actionLabel, onRecalculate }) {
  return (
    <div
      data-testid="dirty-bar"
      role="status"
      className="fixed bottom-5 left-1/2 z-30 flex max-w-[calc(100vw-32px)] -translate-x-1/2 items-center gap-3.5 rounded-2xl border border-warn-border bg-surface py-2 pl-[18px] pr-2 text-[13px] shadow-pop">
      <span className="flex items-center gap-2 font-medium text-warn">
        <AlertTriangle />
        {message}
      </span>
      <PrimaryButton size="sm" onClick={onRecalculate}>
        {actionLabel}
      </PrimaryButton>
    </div>
  );
}

export default DirtyBar;
